import * as React           from "react";

import "./ad-budget-defaults-card-container.scss";

import {cs}                     from "@Common/react/chain-services";
import {scnv}                   from "@Common/react/state-change-nested-value";
import {UseState}               from "@Common/react/use-state";
import {Pagination}             from "@Common/ui-components/heavy/common/design2/data-table/pagination";
import {PageList}               from "@Common/ui-components/heavy/common/design2/pagination-ui/page-list/page-list";
import {PageSize}               from "@Common/ui-components/heavy/common/design2/pagination-ui/page-size/page-size";
import {getPageSummary}         from "@Common/ui-components/heavy/common/design2/data-table/get-page-summary";
import {AdBudgetDefaultsCard}   from "./ad-budget-defaults-card/ad-budget-defaults-card";
import {AD_BUDGET_PLACEHOLDER}  from "../ad-budget-defaults-route";
import {faCaretDown, faCaretUp} from "../../../../../../../node_modules/@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon}        from "../../../../../../../node_modules/@fortawesome/react-fontawesome";

export const AdBudgetDefaultsCardContainer = ({adBudgets, selectedBranches}) => cs(
    ["sortAscending", ({}, next) => UseState({initValue: true, next})],
    ["sortedRows", ({sortAscending}, next) => next(sortedOffices(selectedBranches.value, sortAscending.value))],
    ["pageSize", (_, next) => UseState({initValue: PAGINATION_MIN, next})],
    ["pagination", ({pageSize, sortedRows}, next) => Pagination({
        _key: JSON.stringify(pageSize),
        pageSize: pageSize.value,
        rows: sortedRows,
        next,
    })],
    ["displayedRows", ({pagination, sortedRows}, next) => next(pagination?.active ? pagination.getDisplayedRows() : sortedRows)],
    ({displayedRows, pageSize, pagination, sortAscending}) => (
        <div className="ad-budget-card-container-dp10">
            {
                selectedBranches.value.length > 0 ? (
                    <>
                        <div className="header" >
                            <div 
                                className="header-text"
                                onClick={(e) => {
                                   e.stopPropagation()
                                   pagination.state.onChange(0)
                                   if(sortAscending.value) {
                                        sortAscending.onChange(false)
                                        return
                                   }
                                   sortAscending.onChange(true)
                                }} >
                                OFFICE
                                <FontAwesomeIcon
                                    className="icon"
                                    icon={sortAscending.value ? faCaretUp : faCaretDown}
                                    xd-qa-type="icon"
                                    xd-qa-name="OFFICE Sort Caret"
                                />
                            </div>
                            
                            <div className="header-text">
                                AMOUNT
                            </div>
                        </div>
                        {displayedRows.map((branch, i) => (
                            <React.Fragment key={i}>
                                {AdBudgetDefaultsCard({
                                    branch, 
                                    getAmount: (branch) => {
                                        if(adBudgets.loading) {
                                            return 0
                                        }
                                        return adBudgets.value[branch.idBranch].amount
                                    }, 
                                    setAmount: (idBranch, newAmount) => {
                                        scnv(adBudgets, [idBranch, "amount"], () => newAmount)
                                    }
                                })}
                            </React.Fragment>
                        ))}
                    </>
                ) : (
                    <div className="ad-budget-card-placeholder">
                        {AD_BUDGET_PLACEHOLDER}
                    </div>
                )
            }
            {selectedBranches.value.length > PAGINATION_MIN &&
                <>
                    <div className="controls">
                        {PageSize({state: pageSize, xdQaNamePrefix: "Pending Orders", pageSizeMessage: ""})}               
                        {pagination.active && PageList(pagination)}
                    </div>
                    {getPageSummary({
                        pageIndex: pagination.state.value,
                        pageSize: pageSize.value,
                        count: selectedBranches.value.length
                    })}
                </>
            }
        </div>
    )
)

const PAGINATION_MIN = 10

const sortedOffices = (offices, sortAscending) => {
    if(!offices) {
        return []
    }
    if(!offices.length) {
        return []
    }
    
    const ascending = sortAscending ? 1 : -1
    const sorted = offices.sort((a, b) => {
        const first = a.branchName.toLowerCase() || a.branchLinkId.toLowerCase()
        const second = b.branchName.toLowerCase() || b.branchLinkId.toLowerCase()       
        if(second < first) {
            return ascending
        }
        if(second > first) {
            return -1 * ascending
        }
        return 0
    })

    return sorted
}